import { LIFECYCLE_STAGES } from "@/lib/lifecycle";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

export default function StageTimeline({ currentStatus, compact = false }) {
  const currentIdx =
    LIFECYCLE_STAGES.findIndex((s) => s.id === currentStatus) || 0;

  return (
    <ol
      data-testid="stage-timeline"
      className={cn(
        "flex items-center gap-2 lg:gap-4 w-full",
        compact && "gap-2"
      )}
    >
      {LIFECYCLE_STAGES.map((stage, idx) => {
        const done = idx < currentIdx;
        const active = idx === currentIdx;
        return (
          <li
            key={stage.id}
            data-testid={`stage-${stage.id}`}
            className="flex-1 min-w-0"
          >
            <div className="flex items-center gap-2">
              <span
                className={cn(
                  "w-6 h-6 shrink-0 flex items-center justify-center border text-[10px] font-semibold",
                  active
                    ? "bg-[#C03028] border-[#C03028] text-[#FAF9F6]"
                    : done
                      ? "bg-[#B0895C] border-[#B0895C] text-[#FAF9F6]"
                      : "bg-transparent border-[#E3DED5] text-[#6E6E70]"
                )}
              >
                {done ? <Check size={12} strokeWidth={2.5} /> : idx + 1}
              </span>
              {idx < LIFECYCLE_STAGES.length - 1 && (
                <span
                  className={cn(
                    "flex-1 h-px",
                    done ? "bg-[#B0895C]" : "bg-[#E3DED5]"
                  )}
                />
              )}
            </div>
            {!compact && (
              <div
                className={cn(
                  "mt-2 text-[10px] uppercase tracking-[0.18em] font-semibold truncate",
                  active
                    ? "text-[#2A1F1A]"
                    : done
                      ? "text-[#C03028]"
                      : "text-[#6E6E70]/70"
                )}
              >
                {stage.label}
              </div>
            )}
          </li>
        );
      })}
    </ol>
  );
}
